import { ErrorResponse } from './error-codes'
import { emitReauthRequired } from './re-auth-events'

export const handle401Error = (error: ErrorResponse) => {
  if (error.errorCode === 'totp.required') {
    return
  }

  emitReauthRequired()
}
